import { useTenantData } from '@dev-agents/tenant-context';

import { JiraProductAccessBoundary } from './jira-product-access-boundary';

import { GithubOauthRedirectPage } from './index';

export const StandaloneGithubOauthRedirectPage = () => {
	const { tenantContexts } = useTenantData();
	const cloudId = tenantContexts[0]?.cloudId;

	if (!cloudId) {
		throw new Error('A Jira site is required for the GitHub OAuth redirect');
	}

	return (
		<JiraProductAccessBoundary key={cloudId} cloudId={cloudId}>
			<main>
				<GithubOauthRedirectPage />
			</main>
		</JiraProductAccessBoundary>
	);
};
